<!--<app-menu></app-menu>-->

<div class="container">
    <!--<h2>Pantalla principal</h2>-->
    <app-login></app-login>
</div>

<!--<app-footer></app-footer>-->